export const SETTING_UPDATE_MODAL = 'settingUpdateModal';
export const SETTING_UPDATE_PATH = '/api/settings/:id';
export const SETTING_NEW_HOSTS_PAGE = 'new_hosts_page';
